import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { updateCategoriesListModel } from "src/app/dashboards/models";
import { DashboardService } from "src/app/services/services/dashboard.service";

@Component({
    selector: 'app-dialog-categories',
    templateUrl: './dialog-categories.component.html',
    styleUrls: ['./dialog-categories.component.scss'],
    standalone: false
})
export class DialogCategoriesComponent implements OnInit {

  public category: string = "";

  public deleted: number[] = [];
  public initCategories: any[] = [];
  public existingCategories: any[] = [];
  public notifier: Subject<void> = new Subject<void>();

  constructor(
    private DashboardsService: DashboardService,
    public dialogRef: MatDialogRef<DialogCategoriesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.existingCategories = JSON.parse(JSON.stringify(this.data.categories));
    this.sortCategories();
    this.initCategories = JSON.parse(JSON.stringify(this.data.categories));
    for (let i = 0; i < this.existingCategories.length; i++) {
      this.existingCategories[i]["disabled"] = true;
    }
  }

  addCategory() {
    if (this.category.trim().length > 0) {
      this.existingCategories.unshift({ id: -1, category: this.category, inUse: -1, disabled: true });
      this.sortCategories();
      this.category = "";
    }
  }

  removeCategory(index) {
    if (this.existingCategories[index].inUse === 1) return;
    let id = this.existingCategories[index].id;
    this.existingCategories.splice(index, 1);
    if (id > -1) this.deleted.push(id);
  }

  editCategory(category) {
    let index = this.existingCategories.indexOf(category);
    this.existingCategories[index].disabled = false;
    this.notifier.next();
  }

  onEdit(index) {
    this.existingCategories[index].disabled = true;
    this.sortCategories();
  }

  onSave(): void {
    let added = this.getAddedCategories();

    let changed = this.getChangedCategories();

    var model: updateCategoriesListModel = {
      deleted: this.deleted,
      added: added,
      changed: changed
    }

    this.DashboardsService.updateReportCategories(model).subscribe(data => {
      this.dialogRef.close({ categories: data })
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  isSaveDisabled(): boolean {
    if (this.deleted.length > 0) return false;
    if (this.getAddedCategories().length > 0) return false;
    if (this.getChangedCategories().length > 0) return false;

    return true;
  }

  isAddDisabled(): boolean {
    if (this.category.match(/([\\\""/\|^§£$%¤])+/)) return true;
    if (this.category.length > 0) return false;

    return true;
  }

  getAddedCategories(): any {
    return this.existingCategories.filter(ec => ec.id === -1).map(ec => {
      return {
        id: ec.id,
        category: ec.category
      }
    });
  }

  getChangedCategories(): any {
    return this.existingCategories.filter(
      ec => ec.id !== -1 &&
        (this.initCategories.find(ic => ic.id === ec.id).category !== ec.category)).map(ec => {
          return {
            id: ec.id,
            category: ec.category
          }
        });
  }

  customTrackBy(index: number, obj: any): any {
    return index;
  }

  sortCategories() {
    this.existingCategories.sort((a, b) => {
      return a.category.localeCompare(b.category);
    });
  }
}
